import $fq from './fake_query'

export default (klass) => class EscalationMixin extends klass {

  static targets = [
    ...super.targets,
    'bloodPressureDiastolic',
    'bloodPressureSystolic',
    'bloodPressureDiastolicRepeat',
    'bloodPressureSystolicRepeat',
    'outOfRangeGlyph',
    'outOfRangeGlyphBloodPressureDiastolic',
    'outOfRangeGlyphBloodPressureSystolic',
    'outOfRangeGlyphBloodPressureDiastolicRepeat',
    'outOfRangeGlyphBloodPressureSystolicRepeat',
    'outOfRangeGlyphHba1c',
    'outOfRangeGlyphHemoglobinLevel',
    'outOfRangeGlyphMidUpperArmCircumference',
    'outOfRangeGlyphOxygenSaturation',
    'outOfRangeGlyphPSA',
    'outOfRangeGlyphPulse',
    'outOfRangeGlyphRandomGlucose',
    'outOfRangeGlyphTemperature',
    'outOfRangeGlyphUricAcid',
    'outOfRangeGlyphUrineBilirubin',
    'outOfRangeGlyphUrineBlood',
    'outOfRangeGlyphUrineGlucose',
    'outOfRangeGlyphUrineKeytones',
    'outOfRangeGlyphUrineLeucocytes',
    'outOfRangeGlyphUrineProtein',
    'outOfRangePopover',
    'outOfRangePopoverBloodPressureSystolic',
    'outOfRangePopoverBloodPressureSystolicRepeat',
    'outOfRangePopoverHba1c',
    'outOfRangePopoverHemoglobinLevel',
    'outOfRangePopoverMidUpperArmCircumference',
    'outOfRangePopoverOxygenSaturation',
    'outOfRangePopoverPSA',
    'outOfRangePopoverPulse',
    'outOfRangePopoverRandomGlucose',
    'outOfRangePopoverTemperature',
    'outOfRangePopoverUricAcid',
    'outOfRangePopoverUrineBilirubin',
    'outOfRangePopoverUrineBlood',
    'outOfRangePopoverUrineGlucose',
    'outOfRangePopoverUrineKeytones',
    'outOfRangePopoverUrineLeucocytes',
    'outOfRangePopoverUrineProtein'
  ]

  static values = {
    ...super.values,
    rangeCheckUrl: String
  }

  // ==== Actions

  toggleOutOfRangePopoverBloodPressureDiastolic() {
    this.toggleOutOfRangePopoverBloodPressureSystolic()
  }

  toggleOutOfRangePopoverBloodPressureSystolic() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'BloodPressureSystolic' })
  }

  toggleOutOfRangePopoverBloodPressureDiastolicRepeat() {
    this.toggleOutOfRangePopoverBloodPressureSystolicRepeat()
  }

  toggleOutOfRangePopoverBloodPressureSystolicRepeat() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'BloodPressureSystolicRepeat' })
  }

  toggleOutOfRangePopoverMidUpperArmCircumference() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'MidUpperArmCircumference' })
  }

  toggleOutOfRangePopoverOxygenSaturation() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'OxygenSaturation' })
  }

  toggleOutOfRangePopoverHba1c() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'Hba1c' })
  }

  toggleOutOfRangePopoverHemoglobinLevel() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'HemoglobinLevel' })
  }

  toggleOutOfRangePopoverPSA() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'PSA' })
  }

  toggleOutOfRangePopoverPulse() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'Pulse' })
  }

  toggleOutOfRangePopoverRandomGlucose() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'RandomGlucose' })
  }

  toggleOutOfRangePopoverTemperature() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'Temperature' })
  }

  toggleOutOfRangePopoverUricAcid() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'UricAcid' })
  }

  toggleOutOfRangePopoverUrineBlood() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'UrineBlood' })
  }

  toggleOutOfRangePopoverUrineGlucose() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'UrineGlucose' })
  }

  toggleOutOfRangePopoverUrineLeucocytes() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'UrineLeucocytes' })
  }

  toggleOutOfRangePopoverUrineProtein() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'UrineProtein' })
  }

  toggleOutOfRangePopoverUrineKeytones() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'UrineKeytones' })
  }

  toggleOutOfRangePopoverUrineBilirubin() {
    this.toggleOutOfRangePopoverInternal({ targetStr: 'UrineBilirubin' })
  }

  // ==== Private

  toggleOutOfRangePopoverInternal({ targetStr } = {}) {
    const popover = this.outOfRangePopoverTargets.find((target) => target.dataset.outOfRangeFrame === targetStr) ||
      this[`outOfRangePopover${targetStr}Target`]

    if ($fq(popover).hasClass('u-hide')) {
      this.outOfRangePopoverTargets.forEach((elPopover) => {
        if (elPopover !== popover && !$fq(elPopover).hasClass('u-hide')) {
          $fq(elPopover).hide()
        }
      })

      this.outOfRangeGlyphTargets.forEach((elGlyph) => {
        $fq(elGlyph).changeGlyph('#exclamation-circle')
      })

      this.toggleOutOfRangeGlyph({ glyphStr: '#exclamation-circle-outline', targetStr })

      $fq(popover).show()
      if (popover.popover) popover.showPopover()
    } else {
      this.toggleOutOfRangeGlyph({ glyphStr: '#exclamation-circle', targetStr })

      $fq(popover).hide()
      if (popover.popover) popover.hidePopover()
    }
  }

  toggleOutOfRangeGlyph({ glyphStr, targetStr } = {}) {
    const glyph = this.outOfRangeGlyphTargets.find((target) => target.dataset.outOfRangeFrame === targetStr) ||
      this[`outOfRangeGlyph${targetStr}Target`]

    $fq(glyph).changeGlyph(glyphStr)

    if (/systolic.*repeat/.test(targetStr)) {
      this.toggleOutOfRangeGlyph({ glyphStr, targetStr: 'BloodPressureDiastolicRepeat' })
    } else if (/systolic/.test(targetStr)) {
      this.toggleOutOfRangeGlyph({ glyphStr, targetStr: 'BloodPressureDiastolic' })
    }
  }

}
